module.exports = __webpack_public_path__ + "static/media/126474.2e5a42b6.svg";